import React, { useState } from "react";
import PopUp from "../../components/PopUp";
import { FaTimesCircle } from "react-icons/fa";
import { InfoBlock, RectBtn } from "../../components/General";
import { FormControl, FormHelperText, MenuItem, Select, TextField } from "@mui/material";

import { updateAccount } from "../../apis/Auth.Api";
import { useDispatch, useSelector } from "react-redux";
import { selectUserData } from "../../features/store";
import { PERMISSION } from "../../configs/global";
import { useSnackbar } from "notistack";
import { logOut } from "../../features/slices/userDataSlice";
const EditAccountPopUp = ({
    openEdit,
    setOpenEdit,
    updateName,
    setUpdateName,
    updatePermission,
    setUpdatePermission,
    selectedUser,
    apiRef,
}) => {
    const { enqueueSnackbar } = useSnackbar();
    const dispatch = useDispatch();
    const [validateName, setValidateName] = useState("");
    const [validatePermission, setValidatePermission] = useState("");
    const userData = useSelector(selectUserData);
    function validateInput() {
        let valid = true;
        if (updateName === "") {
            setValidateName("Name cannot be empty");
            valid = false;
        }
        if (updatePermission === "") {
            setValidatePermission("Permission cannot be empty");
            valid = false;
        }

        if (valid) {
            setValidateName("");
            setValidatePermission("");
        }

        return valid;
    }
    async function confirmEditAccount() {
        let valid = validateInput();
        if (!valid) return;
        let r = await updateAccount({
            user_id: selectedUser.userId,
            user_name: updateName,
            permission: updatePermission,
        });
        if (!r.data.indicator) {
            enqueueSnackbar(r.data.message, { variant: "error" });
            return;
        }
        enqueueSnackbar(r.data.message, { variant: "success" });

        apiRef.current.updateRows([{ id: selectedUser.id, name: updateName, permission: updatePermission }]);

        if (selectedUser.userId === userData.userId && updatePermission !== userData.permission) {
            dispatch(logOut());
        }
        setOpenEdit(false);
    }

    return (
        <PopUp width={50} height={60} switchOn={openEdit}>
            <div className="pop-up-content-wrapper">
                <div className="pop-up-row">
                    <h4>Edit User</h4>
                    <FaTimesCircle
                        className="pop-up-close-btn"
                        onClick={() => {
                            setValidateName("");
                            setValidatePermission("");
                            setOpenEdit(false);
                        }}
                    />
                </div>
                <div className="pop-up-division-line"></div>
                <div className="pop-up-body">
                    <div className="edit-user-wrapper">
                        <div className="forms">
                            <InfoBlock title={"Name"}>
                                <TextField
                                    inputProps={{ maxLength: 20 }}
                                    type="text"
                                    value={updateName}
                                    onChange={(e) => {
                                        setUpdateName(e.target.value);
                                    }}
                                    sx={{ minWidth: 180 }}
                                    error={validateName !== ""}
                                    helperText={validateName}
                                />
                            </InfoBlock>

                            <InfoBlock title={"Permission Level"}>
                                <div className="drop-down">
                                    <FormControl sx={{ minWidth: 180 }} error={validatePermission !== ""}>
                                        <Select
                                            id="demo-select-small"
                                            value={updatePermission}
                                            onChange={(e) => {
                                                setUpdatePermission(e.target.value);
                                            }}
                                        >
                                            {userData.permission === PERMISSION.SUPER && (
                                                <MenuItem value={PERMISSION.SUPER}>0 - Super Admin</MenuItem>
                                            )}
                                            <MenuItem value={PERMISSION.ADMIN}>1 - Admin</MenuItem>
                                            <MenuItem value={PERMISSION.MANAGER}>2 - Manager</MenuItem>
                                            <MenuItem value={PERMISSION.VIEWER}>3 - Viewer</MenuItem>
                                        </Select>
                                        <FormHelperText>{validatePermission}</FormHelperText>
                                    </FormControl>
                                </div>
                            </InfoBlock>
                        </div>

                        <div className="edit-user-btn-wrapper">
                            <RectBtn onClick={confirmEditAccount}>Confirm</RectBtn>
                        </div>
                        {selectedUser.userId === userData.userId && updatePermission !== userData.permission && (
                            <p className="edit-account-hint">
                                You are modifying your own account. You will be asked to log-in again if you change your
                                permission level
                            </p>
                        )}
                    </div>
                </div>
            </div>
        </PopUp>
    );
};

export default EditAccountPopUp;
